<template>
  <div id="editPage">
    <van-nav-bar
      style="color: #000"
      title="图片编辑"
      left-text="返回"
      right-text="下一步"
      left-arrow
      @click-left="onClickLeft"
      @click-right="cropImage()"
    />
    <div class="cut">
      <vue-cropper
        id="cropperId"
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="option.info"
        :full="option.full"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        :canScale="option.canScale"
        :enlarge="option.enlarge"
        :render-content="renderContent"
        @real-time="realTime"
        :high="option.high"
        @img-load="imgLoad"
        mode="100%"
        :maxImgSize="option.max"
        style="background-image: none"
        class="cropperImg"
      >
      </vue-cropper>
    </div>
    <div class="tishi">
      <van-icon name="warning-o" />请关注图标和芯片对图片的遮挡，谨慎编辑
    </div>
    <div class="mt-3 actionGroup">
      <span
        @click="changeScale(1)"
        style="width: 50px; height: 50px; text-align: center"
      >
        <van-icon
          name="expand-o"
          size="25"
          style="text-align: center; width: 100%"
        />
        <div style="font-size: 12px; vertical-align: 3px">放大</div>
      </span>
      <span
        @click="changeScale(-1)"
        style="width: 50px; height: 50px; text-align: center"
      >
        <van-icon
          name="shrink"
          size="25"
          style="text-align: center; width: 100%"
        />
        <div style="font-size: 12px">缩小</div>
      </span>
      <span
        @click="rotateLeft"
        style="width: 50px; height: 50px; text-align: center"
      >
        <van-icon
          name="replay"
          size="25"
          style="transform: rotateY(180deg); text-align: center; width: 100%"
        />
        <div style="font-size: 12px">左旋</div>
      </span>
      <span
        @click="rotateRight"
        style="width: 50px; height: 50px; text-align: center"
      >
        <van-icon
          name="replay"
          size="25"
          style="text-align: center; width: 100%"
        />
        <div style="font-size: 12px">右旋</div>
      </span>
      <!-- <b-button @click="changeScale(1)" variant="primary">放大</b-button> -->
      <!-- <b-button @click="changeScale(-1)" variant="primary">缩小</b-button> -->
      <!-- <b-button @click="rotateLeft" variant="primary">左旋</b-button> -->
      <!-- <b-button @click="rotateRight" variant="primary">右旋</b-button> -->
    </div>
    <!-- <div class="mt-3 devDone">
      <b-button variant="primary" @click="cropImage()">完成</b-button>
    </div> -->

    <b-modal ok-only ref="model_tip" title="提示" ok-title="确定">
      <p class="my-4">截图框内不能留有空白，请放大或缩小图片</p>
    </b-modal>
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import wx from "weixin-js-sdk";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "EditCardface_zy",
  components: {},
  data() {
    return {
      imgPath: "",
      bankSerialNumber: "",
      messageData: "",
      bankCode: "",
      selectParam: null,
      progressValue: 0, //缩放进度条值
      modValue: 0, //默认值
      zoomValue: 0, //缩放大小
      maxScale: 15, //最大缩放
      progressValue1: 10, //亮度进度条值
      modValue1: 10, //默认值
      LuminanceValue: 10, //亮度大小
      maxLuminance: 20, //最大的亮度
      fileData: null, //文件流
      isOverturn: false, //是否翻转
      isShow: 1, //1：是否缩放，2：亮度,3：旋转，4：翻转
      cardOri: "",
      cardTheme: "",
      isHorizontal: true, //横、竖版
      //银联标
      frontCoverH: config.config_zy.frontCoverH, //横版正面
      frontCoverV: config.config_zy.frontCoverV, //竖版正面
      backCoverH: config.config_zy.backCoverH,
      backCoverV: config.config_zy.backCoverV,
      option: {
        img: "",
        size: 1,
        info: false,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        scaleY: "",
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 150,
        centerBox: false,
        high: true,
        max: 2000,
        fixed: true,
        fixedNumber: [14, 9],
        canScale: true,
        enlarge: 1,
      },
      initScale: "",
      errorMsg: "",
      targetImg: "",

      // sqjNo: "",
      // cardLevel: "",
      // cardProduct: "",
      // creditDate: "",
    };
  },
  computed: {
    coverImagesWrapper: function () {
      var temp = this.coverImages;
      var array = [];
      if (temp.length > 0) {
        array = new Array(temp.length);
        for (var i = 0; i < temp.length; i++) {
          var obj = temp[i];
          obj.h_front = obj.h_front;
          obj.h_back = obj.h_back;
          obj.v_front = obj.v_front;
          obj.v_back = obj.v_back;
          // obj.h_front = config.baseCardfaceUrl + obj.h_front;
          // obj.h_back = config.baseCardfaceUrl + obj.h_back;
          // obj.v_front = config.baseCardfaceUrl + obj.v_front;
          // obj.v_back = config.baseCardfaceUrl + obj.v_back;
          array[i] = obj;
        }
      }
      return array;
    },
  },
  methods: {
    //展示样式
    renderContent() {
      return <div style="background:red;width:50px;height:50px;">12345789</div>;
    },
    //返回按钮
    onClickLeft() {
      // this.$router.go(-1);
      this.$router.replace({
        name: "SelectCardface_zy",
        params: {
          bank: 0,
        },
      });
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    handleOk: function (bvModalEvt) {},
    showCropTip: function () {
      this.$refs["model_tip"].show();
    },
    // 实时预览函数
    realTime(data) {
      // console.log("realTime 未翻转");
      let w = this.$refs.cropper.cropW;
      let h = this.$refs.cropper.cropH;
      // 图片缩放比例
      let scale = this.$refs.cropper.scale;
      // 图片偏移x轴
      let x = this.$refs.cropper.x;
      // 图片偏移y轴
      let y = this.$refs.cropper.y;
      // 图片真实宽度
      let trueWidth = this.$refs.cropper.trueWidth;
      // 图片真实高度
      let trueHeight = this.$refs.cropper.trueHeight;
      // 裁剪框的坐标轴
      let cropX = this.$refs.cropper.cropX;
      let cropY = this.$refs.cropper.cropY;
      // console.log("截图框宽高：" + w + "*" + h);
      // console.log("图片缩放比例：" + scale);
      // console.log("图片偏移x轴：" + x);
      // console.log("图片偏移y轴：" + y);
      // console.log("图片真实宽度：" + trueWidth);
      // console.log("图片真实高度：" + trueHeight);
      // console.log("裁剪框的坐标轴：" + cropX + "*" + cropY);

      // console.log(data)
    },

    imgLoad(msg) {
      console.log(msg, 111);
      // 图片初始缩放比例
      let scale = this.$refs.cropper.scale;
      this.initScale = scale;
      let cropperObj = this.$refs.cropper;
      let maxWidth = cropperObj.w;
      let maxHeight = cropperObj.h;
      let imgW = cropperObj.trueWidth * cropperObj.scale;
      let imgH = cropperObj.trueHeight * cropperObj.scale;
      maxWidth = imgW < maxWidth ? imgW : maxWidth;
      maxHeight = imgH < maxHeight ? imgH : maxHeight;

      console.log("maxWidth:" + maxWidth);
      console.log("maxHeight:" + maxHeight);
      console.log("imgW:" + imgW);
      console.log("imgH:" + imgH);
      console.log("maxWidth:" + maxWidth);
      console.log("maxWidth:" + maxWidth);
      console.log("initScale:" + this.initScale);
      // if (this.cardOri == 0) {
      //   //横版
      //   this.option.autoCropWidth = maxWidth *0.8;
      //   this.option.autoCropHeight = maxWidth *0.8 * 9/16;
      //   console.log('autoCropWidth:' + this.option.autoCropWidth)
      //   console.log('autoCropHeight:' + this.option.autoCropHeight)
      //   this.option.fixedNumber = [16, 9];
      // } else if (this.cardOri == 1) {
      //   //竖版
      //   this.option.autoCropWidth = maxHeight *0.8 * 9/16;
      //   this.option.autoCropHeight = maxHeight *0.8;
      //   console.log('autoCropWidth:' + this.option.autoCropWidth)
      //   console.log('autoCropHeight:' + this.option.autoCropHeight)
      //   this.option.fixedNumber = [9, 16];
      // }

      if (this.cardOri == 0) {
        //横版
        this.option.autoCropWidth = maxWidth * 0.9;
        this.option.autoCropHeight = (maxWidth * 0.9 * 9) / 16;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [14, 9];
      } else if (this.cardOri == 1) {
        //竖版
        this.option.autoCropWidth = (maxHeight * 0.9 * 9) / 16;
        this.option.autoCropHeight = maxHeight * 0.9;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [9, 14];
      }
    },
    //判断是否留有白边，是否在框内
    hasWhiteSpace: function () {
      let has = true;
      let axis = this.$refs.cropper.getImgAxis();
      let cropAxis = this.$refs.cropper.getCropAxis();
      console.log(`axis`, axis);
      console.log(`cropAxis`, cropAxis);

      // 左边的横坐标 图片不能超过截图框
      if (axis.x1 >= cropAxis.x1) {
        console.log(`11`, 1);
        has = false;
      }
      // 右边横坐标
      if (axis.x2 <= cropAxis.x2) {
        console.log(`21`, 2);
        has = false;
      }
      // 纵坐标上面
      if (axis.y1 >= cropAxis.y1) {
        console.log(`31`, 3);
        has = false;
      }
      // 纵坐标下面
      if (axis.y2 <= cropAxis.y2) {
        console.log(`41`, 4);
        has = false;
      }

      return has;
    },
    cropImage: function () {
      // var canvas = this.cropper.getCroppedCanvas();
      // var dataURL = canvas.toDataURL('img/png', 0.3);
      // localStorage.setItem('destImg', dataURL);
      // this.toUploadCardface();

      var that = this;
      let has = that.hasWhiteSpace();
      if (!has) {
        that.showCropTip();
        return;
      }

      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob((data) => {
        // do something
        console.log(data);

        let url = window.URL.createObjectURL(data);
        this.targetImg = url;
        console.log("blob url:" + url);
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载
          console.log("图片宽高:" + w + "*" + h);
          if (that.cardOri == 0) {
            //横版
            if (w >= 1024 && h >= 665) {
              that.toUploadCardface();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，剪裁后的图片像素：" + w + "*" + h;
              that.showErrorMsg();
            }
          } else if (that.cardOri == 1) {
            //竖版
            if (w >= 665 && h >= 1024) {
              that.toUploadCardface();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，剪裁后的图片像素：" + w + "*" + h;
              that.showErrorMsg();
            }
          }
        };
      });
    },
    toUploadCardface() {
      var selectParam = JSON.stringify(this.selectParam);
      let cardThemeParam = JSON.stringify(this.cardTheme);
      this.$router.replace({
        name: "UploadCardface_zy",
        params: {
          // bankSerialNumber: this.bankSerialNumber,
          // bankCode: this.bankCode,
          // selectParam: selectParam,
          // messageData: this.messageData,
          cardOri: this.cardOri,
          cardTheme: cardThemeParam,
          targetImg: this.targetImg, //blob文件
          fileData: this.fileData, //文件
          // sqjNo: this.sqjNo,
          // cardLevel: this.cardLevel,
          // cardProduct: this.cardProduct,
          // creditDate: this.creditDate,
        },
      });
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    //调节缩放大小
    changeScale(num, flag) {
      if (flag && flag) {
        num = num || 1;
        if (num > 0) {
          if (this.zoomValue < this.maxScale) {
            this.zoomValue = this.zoomValue + num;
            this.$refs.cropper.changeScale(num);
          }
        } else {
          // if (this.zoomValue > 40) {
          this.zoomValue = this.zoomValue + num;
          this.$refs.cropper.changeScale(num);
          // }
        }
      } else {
        num = num || 1;
        if (num > 0) {
          if (this.zoomValue < this.maxScale) {
            this.zoomValue = this.zoomValue + num;
            this.$refs.cropper.changeScale(num);
          }
        } else {
          // if (this.zoomValue > 40) {
          this.zoomValue = this.zoomValue + num;
          this.$refs.cropper.changeScale(num);
          // }
        }
        this.progressValue = this.progressValue + num;
      }
      this.modValue = this.progressValue;
      // console.log(`缩放`, this.zoomValue);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    getLayoutImageByBankCode: function () {
      let that = this;
      axios
        .get(config.config_zy.getLayoutImageByBankCode, {
          params: {
            bankCode: config.config_zy.bankCode,
          },
        })
        .then(function (response) {
          // console.log(response);
          let data = response.data;
          that.coverImages = data;
          // console.log(that.coverImagesWrapper);
          var wrapper = that.coverImagesWrapper;
          for (var i = 0; i < wrapper.length; i++) {
            var item = wrapper[i];
            //默认卡面
            if (item.model == 1) {
              that.frontCoverH = item.h_front;
              that.backCoverH = item.h_back;
              that.frontCoverV = item.v_front;
              that.backCoverV = item.v_back;
            }
            console.log("frontCoverH:" + that.frontCoverH);
            console.log("frontCoverV:" + that.frontCoverV);
            // console.log("backCoverH:" + that.backCoverH);
            // console.log("backCoverV:" + that.backCoverV);
            let cropperFace = document.querySelector(".cropper-face");
            let cropperBox = document.querySelector(".cropper-view-box");
            let cut = document.querySelector(".cut");
            cut.style.cssText += "position: relative;";
            cropperFace.style.cssText += "display: inline-block;";
            let div1 = document.createElement("div");
            let div1img = document.createElement("img");
            div1img.src = `${
              that.cardOri == 0 ? that.frontCoverH : that.frontCoverV
            }`;
            div1img.style.cssText = `width:100%;height:100%;pointer-events: none;`;
            div1.appendChild(div1img);
            // div1.style.cssText = `width:100px;height:100px;position: absolute;right:20px;bottom:20px;z-index:100;`;
            div1.style.cssText = `width:100%;height:100%;position: absolute;right:0;bottom:0;z-index:100;pointer-events: none;`;
            cropperBox.appendChild(div1);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted: function () {
    let cropperBox = document.querySelector(".cropper-drag-box");
    cropperBox.style.cssText += "background:#DDDDDD";

    //获取卡面图片地址
    // this.getLayoutImageByBankCode();

    this.imgPath = this.$route.params.imagePath;
    // console.log("imgPath:" + this.imgPath);
    this.option.img = this.imgPath;

    // this.bankSerialNumber = this.$route.params.bankSerialNumber;
    // console.log('bankSerialNumber:' + this.bankSerialNumber);

    // this.messageData = this.$route.params.messageData;

    // this.bankCode = this.$route.params.bankCode;
    // console.log('bankCode:' + this.bankCode);

    // var selectParam = this.$route.params.selectParam;
    // console.log('selectParam:' + selectParam)
    // if (selectParam !== undefined) {
    //   this.selectParam = JSON.parse(selectParam);
    // }
    this.cardOri = this.$route.params.cardOri;
    // console.log('cardOri:' + this.cardOri)
    this.fileData = this.$route.params.file;

    // this.sqjNo = this.$route.params.sqjNo;
    // console.log("sqjNo:" + this.sqjNo);
    // this.cardLevel = this.$route.params.cardLevel;
    // this.cardProduct = this.$route.params.cardProduct;
    // this.creditDate = this.$route.params.creditDate;

    // if (this.cardOri == 0) {
    //   //横版
    //   this.option.autoCropWidth = 331;
    //   this.option.autoCropHeight = 186;
    //   this.option.fixedNumber = [16, 9];
    // } else if (this.cardOri == 1) {
    //   //竖版
    //   this.option.autoCropWidth = 186;
    //   this.option.autoCropHeight = 331;
    //   this.option.fixedNumber = [9, 16];
    // }

    // let themeParam = this.$route.params.cardTheme;
    // console.log("themeParam:" + themeParam);
    // if (themeParam !== undefined) {
    //   this.cardTheme = JSON.parse(themeParam);
    // }

    //this.wxJsSdk();
  },
};
</script>

<style scoped lang="less">
.cut {
  width: 100vw;
  height: 75vh;
}
.tishi {
  color: #cc0033;
  text-align: center;
  padding: 10px 0 0 0;
  background: #eee;
}

.test-button {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

.actionGroup {
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.devDone {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 16px;
}

/* .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all .2s ease;
    text-decoration: none;
    user-select: none;
  } */
</style>



// WEBPACK FOOTER //
// src/components/zyBank/EditCardface_zy.vue